import httpRequest from '@/utils/request.js';

// 根据key获取设备
export const getDevices = key =>
    httpRequest.httpGet({
        url: `/service/device/enrollment/get/${key}`,
    });

// 保存设备
export const saveDevices = (data) => httpRequest.httpPost('/service/device/enrollment/save', data)

// 获取自定义设备列表
export const  getDeviceMonitorList = ()  =>
  httpRequest.httpGet({
    url: `/service/device/monitor/scene/list`,
  })
// 保存自定义设备列表
export const  saveDeviceMonitor = (params)  =>
  httpRequest.httpPost( `/service/device/monitor/save/scene`, params)

// 删除自定义设备列表
export const  deleteDeviceMonitor = (params)  =>
  httpRequest.httpdelete( `/service/device/monitor/delete/scene`, params)

//获取架构设备
export const  getSceneDeviceList = (params)  =>
httpRequest.httpGet({
  url: `/service/device/monitor/getSceneDeviceList`,
  params
})

//获取设备注册监测点列表
export const  getRegisterCarrierList = (params = {})  =>
  httpRequest.httpGet({
    url: `/service/device/enrollment/carrier/list`, params: {
      ...params
    }
  })
// 保存注册监测点
export const  saveRegisterCarrier = (params)  =>
  httpRequest.httpPost( `/service/device/enrollment/save/carrier`, params)
// 获取所有选中的设备列表
export const  getSceneDeviceSelectedList = ()  =>
httpRequest.httpGet({
  url: `/service/device/monitor/selected/data`
})
// 获取设备注册监测点详情
export const  getRegisterCarrierDetail = (id)  =>
  httpRequest.httpGet( {
    url: `/service/device/enrollment/carrier/${id}`
  })
// 设备注册获取设备列表
export const  getRegisterDeviceList = ()  =>
  httpRequest.httpGet( {
    url: `/service/device/enrollment/device/list`
  })

